// src/utils/hsnSummary.js

export const HSN_LIST = ["24022090", "24022050", "24022040", "24022030"];

export function buildHsnSummary(items, skuMaster, source = "DS_APP") {
  const summary = {};

  // Init rows
  HSN_LIST.forEach(hsn => {
    summary[hsn] = {
      description: "CIGARETTE",
      qty: 0,
      basic: 0,
      gstAmt: 0,
      cessAmt: 0,
      addlAmt: 0,
      total: 0,
    };
  });

  // LOOP THROUGH ALL SKUs & CALCULATE EXACT VALUES
  Object.keys(items || {}).forEach(sku => {
    const qty = Number(items[sku] || 0);
    if (qty === 0) return;

    const s = skuMaster[sku];
    if (!s) return;

    const hsn = String(s.HSN || s.hsn || "").trim();

    if (!HSN_LIST.includes(hsn)) return;

    // 🚀 MULTI-TIER PRICING LOGIC
    let rate = Number(s.Basic_Eway || 0);
    if (source === "DISTRIBUTOR_TO_DS") {
        rate = Number(s.dsBasicRate || s.Basic_Eway || 0);
    } else if (source === "DISTRIBUTOR_APP") {
        rate = Number(s.distributorBasicRate || s.Basic_Eway || 0);
    }

    const gst = Number(s.gst || 0);
    const cess = Number(s.cess || 0);
    const addl = Number(s.addlcess || 0);

    const BASIC = qty * rate;
    const GST = BASIC * (gst / 100);
    const CESS = BASIC * (cess / 100);
    const ADDL = qty * addl;

    const row = summary[hsn];
    row.qty += qty;
    row.basic += BASIC;
    row.gstAmt += GST;
    row.cessAmt += CESS;
    row.addlAmt += ADDL;
    row.total += BASIC + GST + CESS + ADDL;
    if (s.Name) row.name = s.Name;
  });

  return summary;
}
